import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtRomeDateTime } from "@/lib/clubTime";

const ACTION = { create: "Creazione", update: "Modifica", delete: "Eliminazione", complete: "Chiusura", cancel: "Annullamento" };
const FIELD = {
  athlete_id: "atleta", athlete_ids: "atleta", coach_id: "tecnico", lead_coach_id: "tecnico", date: "data", duration: "durata",
  duration_min: "durata", objective: "obiettivo", topics: "contenuti", corrections: "correzioni", evaluation: "valutazione",
  next_objective: "prossimo obiettivo", tags: "tag", content_tag_codes: "tag", training_id: "allenamento", session_id: "seduta",
  status: "stato", notes: "note", intensity: "intensità",
};

// Cronologia delle operazioni: solo autore, data/ora, tipo e nomi dei campi (mai i testi della lezione).
export default function LessonHistoryDialog({ row, onClose }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!row) return;
    setItems(null); setError(null);
    api.get(`/lessons/${row.id}/audit`).then((r) => setItems(r.data)).catch((e) => setError(e.response?.data?.detail || "Cronologia non disponibile"));
  }, [row]);
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="lesson-history-dialog">
        <DialogHeader>
          <DialogTitle>Cronologia della lezione</DialogTitle>
          <DialogDescription data-testid="lesson-history-subtitle">
            {row ? `${row.athlete_name} · lezione del ${row.date || "—"} · registrata il ${fmtRomeDateTime(row.created_at)}` : ""}
          </DialogDescription>
        </DialogHeader>
        {error && <div className="text-sm text-red-600" data-testid="lesson-history-error">{error}</div>}
        {!error && items === null && <div className="text-sm text-zinc-500">Caricamento…</div>}
        {items && items.length === 0 && (
          <div className="text-sm text-zinc-500" data-testid="lesson-history-empty">
            Nessuna operazione registrata: la lezione è precedente all'attivazione della cronologia.
          </div>
        )}
        {items && items.length > 0 && (
          <ol className="space-y-2" data-testid="lesson-history-list">
            {items.map((it) => (
              <li key={it.seq} className="border-l-2 border-zinc-300 pl-3" data-testid={`lesson-history-item-${it.seq}`}>
                <div className="text-sm font-medium">{ACTION[it.action] || it.action}</div>
                <div className="text-xs text-zinc-600">{fmtRomeDateTime(it.at)} · {it.actor_name}{it.actor_role ? ` (${it.actor_role})` : ""}</div>
                {it.action === "update" && it.changed_fields?.length > 0 && (
                  <div className="text-xs text-zinc-500">Campi modificati: {[...new Set(it.changed_fields.map((f) => FIELD[f] || f))].join(", ")}</div>
                )}
              </li>
            ))}
          </ol>
        )}
      </DialogContent>
    </Dialog>
  );
}
